import { render, staticRenderFns } from "./TractNumber.vue?vue&type=template&id=255d3655&scoped=true&lang=pug"
import script from "./TractNumber.vue?vue&type=script&lang=ts"
export * from "./TractNumber.vue?vue&type=script&lang=ts"
import style0 from "./TractNumber.vue?vue&type=style&index=0&id=255d3655&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255d3655",
  null
  
)

export default component.exports